/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./Header/Header"
import "./layout.css"
import { GlobalStyles } from "./globalStyles"
import { theme } from "./theme"
import { useLocation } from "@reach/router";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const location = useLocation();
  const hideHeader = location.pathname.startsWith("/fortheparentless/");


  return (
    <>
      <GlobalStyles theme={theme} />
      {!hideHeader && <Header siteTitle={data.site.siteMetadata?.title || `Title`} />}
      <div
        style={{
          margin: `0 auto`,
        }}
      >
        <main>{children}</main>
        <footer
          style={{
            marginTop: `2rem`,
            fontSize: `12px`,
          }}
        >
          {/* © {new Date().getFullYear()}, Built with
          {` `}
          <a href="https://www.gatsbyjs.com">Gatsby</a> */}
        </footer>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
